const countryOptions = [
    { value: "84", label: "Vietnam", flag: "VN" },
    { value: "93", label: "Afghanistan", flag: "AF" },
    { value: "355", label: "Albania", flag: "AL" },
    { value: "213", label: "Algeria", flag: "DZ" },
    { value: "376", label: "Andorra", flag: "AD" },
    { value: "244", label: "Angola", flag: "AO" },
    { value: "1264", label: "Anguilla", flag: "AI" },
    { value: "672", label: "Antarctica", flag: "AQ" },
    { value: "54", label: "Argentina", flag: "AR" },
    { value: "374", label: "Armenia", flag: "AM" },
    { value: "297", label: "Aruba", flag: "AW" },
    { value: "61", label: "Australia", flag: "AU" },
    { value: "43", label: "Austria", flag: "AT" },
    { value: "994", label: "Azerbaijan", flag: "AZ" },
    { value: "1242", label: "Bahamas", flag: "BS" },
    { value: "973", label: "Bahrain", flag: "BH" },
    { value: "880", label: "Bangladesh", flag: "BD" },
    { value: "1246", label: "Barbados", flag: "BB" },
    { value: "375", label: "Belarus", flag: "BY" },
    { value: "32", label: "Belgium", flag: "BE" },
    { value: "501", label: "Belize", flag: "BZ" },
    { value: "229", label: "Benin", flag: "BJ" },
    { value: "1441", label: "Bermuda", flag: "BM" },
    { value: "975", label: "Bhutan", flag: "BT" },
    { value: "591", label: "Bolivia", flag: "BO" },
    { value: "267", label: "Botswana", flag: "BW" },
    { value: "55", label: "Brazil", flag: "BR" },
    { value: "673", label: "Brunei", flag: "BN" },
    { value: "359", label: "Bulgaria", flag: "BG" },
    { value: "226", label: "Burkina Faso", flag: "BF" },
    { value: "257", label: "Burundi", flag: "BI" },
    { value: "855", label: "Cambodia", flag: "KH" },
    { value: "237", label: "Cameroon", flag: "CM" },
    { value: "1", label: "Canada", flag: "CA" },
    { value: "238", label: "Cape Verde", flag: "CV" },
    { value: "235", label: "Chad", flag: "TD" },
    { value: "56", label: "Chile", flag: "CL" },
    { value: "86", label: "China", flag: "CN" },
    { value: "57", label: "Colombia", flag: "CO" },
    { value: "269", label: "Comoros", flag: "KM" },
    { value: "243", label: "Congo (DRC)", flag: "CD" },
    { value: "242", label: "Congo (Republic)", flag: "CG" },
    { value: "682", label: "Cook Islands", flag: "CK" },
    { value: "506", label: "Costa Rica", flag: "CR" },
    { value: "225", label: "Cote d'Ivoire", flag: "CI" },
    { value: "385", label: "Croatia", flag: "HR" },
    { value: "53", label: "Cuba", flag: "CU" },
    { value: "357", label: "Cyprus", flag: "CY" },
    { value: "420", label: "Czech Republic", flag: "CZ" },
    { value: "45", label: "Denmark", flag: "DK" },
    { value: "253", label: "Djibouti", flag: "DJ" },
    { value: "1767", label: "Dominica", flag: "DM" },
    { value: "1", label: "Dominican Republic", flag: "DO" },
    { value: "593", label: "Ecuador", flag: "EC" },
    { value: "20", label: "Egypt", flag: "EG" },
    { value: "503", label: "El Salvador", flag: "SV" },
    { value: "240", label: "Equatorial Guinea", flag: "GQ" },
    { value: "291", label: "Eritrea", flag: "ER" },
    { value: "372", label: "Estonia", flag: "EE" },
    { value: "251", label: "Ethiopia", flag: "ET" },
    { value: "500", label: "Falkland Islands", flag: "FK" },
    { value: "298", label: "Faroe Islands", flag: "FO" },
    { value: "679", label: "Fiji", flag: "FJ" },
    { value: "358", label: "Finland", flag: "FI" },
    { value: "33", label: "France", flag: "FR" },
    { value: "689", label: "French Polynesia", flag: "PF" },
    { value: "241", label: "Gabon", flag: "GA" },
    { value: "220", label: "Gambia", flag: "GM" },
    { value: "995", label: "Georgia", flag: "GE" },
    { value: "49", label: "Germany", flag: "DE" },
    { value: "233", label: "Ghana", flag: "GH" },
    { value: "350", label: "Gibraltar", flag: "GI" },
    { value: "30", label: "Greece", flag: "GR" },
    { value: "299", label: "Greenland", flag: "GL" },
    { value: "1473", label: "Grenada", flag: "GD" },
    { value: "1671", label: "Guam", flag: "GU" },
    { value: "502", label: "Guatemala", flag: "GT" },
    { value: "224", label: "Guinea", flag: "GN" },
    { value: "245", label: "Guinea-Bissau", flag: "GW" },
    { value: "592", label: "Guyana", flag: "GY" },
    { value: "509", label: "Haiti", flag: "HT" },
    { value: "504", label: "Honduras", flag: "HN" },
    { value: "852", label: "Hong Kong", flag: "HK" },
    { value: "36", label: "Hungary", flag: "HU" },
    { value: "354", label: "Iceland", flag: "IS" },
    { value: "91", label: "India", flag: "IN" },
    { value: "62", label: "Indonesia", flag: "ID" },
    { value: "98", label: "Iran", flag: "IR" },
    { value: "964", label: "Iraq", flag: "IQ" },
    { value: "353", label: "Ireland", flag: "IE" },
    { value: "44", label: "Isle of Man", flag: "IM" },
    { value: "972", label: "Israel", flag: "IL" },
    { value: "39", label: "Italy", flag: "IT" },
    { value: "1876", label: "Jamaica", flag: "JM" },
    { value: "81", label: "Japan", flag: "JP" },
    { value: "962", label: "Jordan", flag: "JO" },
    { value: "7", label: "Kazakhstan", flag: "KZ" },
    { value: "254", label: "Kenya", flag: "KE" },
    { value: "686", label: "Kiribati", flag: "KI" },
    { value: "965", label: "Kuwait", flag: "KW" },
    { value: "996", label: "Kyrgyzstan", flag: "KG" },
    { value: "856", label: "Laos", flag: "LA" },
    { value: "371", label: "Latvia", flag: "LV" },
    { value: "961", label: "Lebanon", flag: "LB" },
    { value: "266", label: "Lesotho", flag: "LS" },
    { value: "231", label: "Liberia", flag: "LR" },
    { value: "218", label: "Libya", flag: "LY" },
    { value: "423", label: "Liechtenstein", flag: "LI" },
    { value: "370", label: "Lithuania", flag: "LT" },
    { value: "352", label: "Luxembourg", flag: "LU" },
    { value: "853", label: "Macau", flag: "MO" },
    { value: "389", label: "Macedonia", flag: "MK" },
    { value: "261", label: "Madagascar", flag: "MG" },
    { value: "265", label: "Malawi", flag: "MW" },
    { value: "60", label: "Malaysia", flag: "MY" },
    { value: "960", label: "Maldives", flag: "MV" },
    { value: "223", label: "Mali", flag: "ML" },
    { value: "356", label: "Malta", flag: "MT" },
    { value: "692", label: "Marshall Islands", flag: "MH" },
    { value: "222", label: "Mauritania", flag: "MR" },
    { value: "230", label: "Mauritius", flag: "MU" },
    { value: "262", label: "Mayotte", flag: "YT" },
    { value: "52", label: "Mexico", flag: "MX" },
    { value: "691", label: "Micronesia", flag: "FM" },
    { value: "373", label: "Moldova", flag: "MD" },
    { value: "377", label: "Monaco", flag: "MC" },
    { value: "976", label: "Mongolia", flag: "MN" },
    { value: "382", label: "Montenegro", flag: "ME" },
    { value: "1664", label: "Montserrat", flag: "MS" },
    { value: "212", label: "Morocco", flag: "MA" },
    { value: "258", label: "Mozambique", flag: "MZ" },
    { value: "95", label: "Myanmar", flag: "MM" },
    { value: "264", label: "Namibia", flag: "NA" },
    { value: "674", label: "Nauru", flag: "NR" },
    { value: "977", label: "Nepal", flag: "NP" },
    { value: "31", label: "Netherlands", flag: "NL" },
    { value: "687", label: "New Caledonia", flag: "NC" },
    { value: "64", label: "New Zealand", flag: "NZ" },
    { value: "505", label: "Nicaragua", flag: "NI" },
    { value: "227", label: "Niger", flag: "NE" },
    { value: "234", label: "Nigeria", flag: "NG" },
    { value: "683", label: "Niue", flag: "NU" },
    { value: "850", label: "North Korea", flag: "KP" },
    { value: "47", label: "Norway", flag: "NO" },
    { value: "968", label: "Oman", flag: "OM" },
    { value: "92", label: "Pakistan", flag: "PK" },
    { value: "680", label: "Palau", flag: "PW" },
    { value: "970", label: "Palestine", flag: "PS" },
    { value: "507", label: "Panama", flag: "PA" },
    { value: "675", label: "Papua New Guinea", flag: "PG" },
    { value: "595", label: "Paraguay", flag: "PY" },
    { value: "51", label: "Peru", flag: "PE" },
    { value: "63", label: "Philippines", flag: "PH" },
    { value: "64", label: "Pitcairn Islands", flag: "PN" },
    { value: "48", label: "Poland", flag: "PL" },
    { value: "351", label: "Portugal", flag: "PT" },
    { value: "1787", label: "Puerto Rico", flag: "PR" },
    { value: "974", label: "Qatar", flag: "QA" },
    { value: "40", label: "Romania", flag: "RO" },
    { value: "7", label: "Russia", flag: "RU" },
    { value: "250", label: "Rwanda", flag: "RW" },
    { value: "590", label: "Saint Barthelemy", flag: "BL" },
    { value: "290", label: "Saint Helena", flag: "SH" },
    { value: "1758", label: "Saint Lucia", flag: "LC" },
    { value: "590", label: "Saint Martin", flag: "MF" },
    { value: "685", label: "Samoa", flag: "WS" },
    { value: "378", label: "San Marino", flag: "SM" },
    { value: "966", label: "Saudi Arabia", flag: "SA" },
    { value: "221", label: "Senegal", flag: "SN" },
    { value: "381", label: "Serbia", flag: "RS" },
    { value: "248", label: "Seychelles", flag: "SC" },
    { value: "232", label: "Sierra Leone", flag: "SL" },
    { value: "65", label: "Singapore", flag: "SG" },
    { value: "1721", label: "Sint Maarten", flag: "SX" },
    { value: "421", label: "Slovakia", flag: "SK" },
    { value: "386", label: "Slovenia", flag: "SI" },
    { value: "677", label: "Solomon Islands", flag: "SB" },
    { value: "252", label: "Somalia", flag: "SO" },
    { value: "27", label: "South Africa", flag: "ZA" },
    { value: "82", label: "South Korea", flag: "KR" },
    { value: "211", label: "South Sudan", flag: "SS" },
    { value: "34", label: "Spain", flag: "ES" },
    { value: "94", label: "Sri Lanka", flag: "LK" },
    { value: "249", label: "Sudan", flag: "SD" },
    { value: "597", label: "Suriname", flag: "SR" },
    { value: "268", label: "Swaziland", flag: "SZ" },
    { value: "46", label: "Sweden", flag: "SE" },
    { value: "41", label: "Switzerland", flag: "CH" },
    { value: "963", label: "Syria", flag: "SY" },
    { value: "886", label: "Taiwan", flag: "TW" },
    { value: "992", label: "Tajikistan", flag: "TJ" },
    { value: "255", label: "Tanzania", flag: "TZ" },
    { value: "66", label: "Thailand", flag: "TH" },
    { value: "228", label: "Togo", flag: "TG" },
    { value: "690", label: "Tokelau", flag: "TK" },
    { value: "676", label: "Tonga", flag: "TO" },
    { value: "1868", label: "Trinidad and Tobago", flag: "TT" },
    { value: "216", label: "Tunisia", flag: "TN" },
    { value: "90", label: "Turkey", flag: "TR" },
    { value: "993", label: "Turkmenistan", flag: "TM" },
    { value: "688", label: "Tuvalu", flag: "TV" },
    { value: "256", label: "Uganda", flag: "UG" },
    { value: "380", label: "Ukraine", flag: "UA" },
    { value: "971", label: "United Arab Emirates", flag: "AE" },
    { value: "44", label: "United Kingdom", flag: "GB" },
    { value: "1", label: "United States", flag: "US" },
    { value: "598", label: "Uruguay", flag: "UY" },
    { value: "998", label: "Uzbekistan", flag: "UZ" },
    { value: "678", label: "Vanuatu", flag: "VU" },
    { value: "39", label: "Vatican City", flag: "VA" },
    { value: "58", label: "Venezuela", flag: "VE" },
    { value: "1340", label: "Virgin Islands", flag: "VI" },
    { value: "681", label: "Wallis and Futuna", flag: "WF" },
    { value: "967", label: "Yemen", flag: "YE" },
    { value: "260", label: "Zambia", flag: "ZM" },
    { value: "263", label: "Zimbabwe", flag: "ZW" },
  ];

  export default countryOptions;